export default {
    requestDurationEditModal: {
        isOpen: false,
        isLoading: false,
        data: {
            expected_duration: null,
            per_position: null,
            min_threshold: 0.0,
            is_revision: false,
            additional_default_time: 0.0,
            type: '',
            suffix: '',
            min_expected_duration: 0.0,
            difficulty_level: '',
        },
        errors: {},
        baseRoute: null,
        requestDurationList: {
            refreshList: false,
        },
    },
};
